import script from "./AllQueriesView.vue?vue&type=script&setup=true&lang=js"
export * from "./AllQueriesView.vue?vue&type=script&setup=true&lang=js"

import "./AllQueriesView.vue?vue&type=style&index=0&id=04d72edf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04d72edf"]])

export default __exports__